/* eslint-disable linebreak-style */
import { createContext } from 'react';

const HeaderContext = createContext({});
export default HeaderContext;
